/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FullOrderViewModel } from './FullOrderViewModel'; 

export function getInDraftOrderForUserOptions(stayid: string, userId: string, onSuccess?: (result?: FullOrderViewModel) => void) {
	return queryOptions({
		queryKey: ['in-draft-order-for-user', stayid, userId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/orders/queries/getindraftorderforuser/' + stayid + '/' + userId;
			const resp = await axios.get<FullOrderViewModel | null>(url);
	        const result = resp.data ?? null;
	        onSuccess?.(result ?? undefined);
	        return result;
        },
        select: (x) => x ?? undefined,
        enabled: Boolean(stayid) && Boolean(userId)
	});
}